import { useSnackbar, VariantType, OptionsObject } from 'notistack';

export const useAlert = () => {
  const { enqueueSnackbar } = useSnackbar();

  const showAlert = (message: string, variant?: VariantType, options?: OptionsObject) => {
    enqueueSnackbar(message, { variant, ...options });
  };

  return showAlert;
};